// extracted by mini-css-extract-plugin
export var baseButton = "_uq-0";
export var controlsArrowKeys = "_uq-1";
export var controlsResetButton = "_uq-2";
export var lightGameButton = "_uq-4 _uq-0";
export var playAgainButton = "_uq-5 _uq-0";
export var startGameButton = "_uq-3 _uq-0";